module.exports = __webpack_public_path__ + "01_mid_black.01c4f344.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_mid_black.png
// module id = o686
// module chunks = 0